import { render } from "./ProductionModal.vue?vue&type=template&id=1470798e&scoped=true"
import script from "./ProductionModal.vue?vue&type=script&lang=js"
export * from "./ProductionModal.vue?vue&type=script&lang=js"

import "./ProductionModal.vue?vue&type=style&index=0&id=1470798e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1470798e"]])

export default __exports__